import Cookies from 'universal-cookie/es6/Cookies';
export const cookies = new Cookies();
